import { useState } from "react";
import { addToCart } from "../cart/cartSlice";
import { CartPopup } from "./CartPopup";
import addtocart from "./addtocart.module.css"


export const AddtoCart = (props) => {
    const [show, setShow] = useState("none")
    
    const addItem = (quantity) => {
        for (let i = 1; i <= quantity; i++){
            props.dispatch(addToCart(props.item.name))
        }
        console.log("Added " + props.item.name + "To cart")
        setShow("block")
        document.body.style.overflow = 'hidden'
    }

    const closePopup = () => {
        setShow("none")
        document.body.style.overflow = 'auto'
    }
    return (
        <div style={{width: "100%" }}>
        <button className={addtocart.addButton} onClick={() => addItem(props.quantity)}>Add to Cart</button>
        <CartPopup show={show} item={props.item} paymentLink = {props.item.paymentLink} closePopup = {closePopup}></CartPopup>
        </div>
    )
}